document.addEventListener("sections:loaded", () => {
  const bundleLists = document.querySelectorAll(".bundle-list");

  bundleLists.forEach((list) => {
    const options = list.querySelectorAll(".bundle-option");

    const syncSelected = () => {
      options.forEach((option) => {
        const input = option.querySelector('input[type="radio"]');
        option.classList.toggle("is-selected", !!input && input.checked);
      });
    };

    list.addEventListener("change", syncSelected);
    syncSelected();
  });
});
